<template>
    <cadastro-simples-form
        endpoint="tipo-documento-anexo"
        rota-base="/admin/tipo-documento-anexo"
        titulo-singular="Tipo de Documento Anexo"
        :campos-extras='[
            { campo: "descricao", label: "Descrição", tipo: "text" }
        ]'>
    </cadastro-simples-form>
</template>

<script>
import CadastroSimplesForm from '@/components/cadastros-auxiliares/cadastro-simples-form.vue'
export default { components: { CadastroSimplesForm } }
</script>
